export default __webpack_public_path__ + "static/media/self3-image.efd3f17e.png";